// Staff-only read-only view of a game. Streams from the spectate
// endpoint (server gates on operate:rpgish) starting at event 0 and
// renders into the same <game-map> with `spectator` set so input
// affordances are inert. No hook modal, no waiting room — just a
// "Spectating" badge.

import { css, html } from 'lit';
import { api } from '../../lib/api.js';
import { BaseComponent } from '../../lib/base-component.js';
import { router } from '../../lib/router.js';

import '../game/game-map.js';

class GameSpectatorView extends BaseComponent {
  static properties = {
    gameId: { type: String, attribute: 'game-id' },
    _currentUserId: { type: String, state: true },
  };

  static styles = css`
    :host { display: block; height: 100%; }
    .spectator-view { width: 100%; height: 100%; position: relative; }
  `;

  constructor() {
    super();
    this.gameId = '';
    this._currentUserId = null;
  }

  _handleExit() {
    router.navigate('/staff/games');
  }

  async connectedCallback() {
    await super.connectedCallback();
    if (!this.gameId) return;
    try {
      const user = /** @type {import('../../types/jsdoc-types.js').User} */ (await api.getMe());
      this._currentUserId = user.id;
    } catch (err) {
      console.error('Failed to initialize spectator view:', err);
    }
  }

  render() {
    return html`
      <div class="spectator-view">
        ${
          this.gameId && this._currentUserId
            ? html`
              <game-map
                game-id="${this.gameId}"
                width="100%"
                height="100%"
                current-user-id="${this._currentUserId}"
                backend-url="${api.getBackendUrl()}"
                spectator
                @exit-spectator="${this._handleExit}"
              ></game-map>
            `
            : ''
        }
      </div>
    `;
  }
}

customElements.define('game-spectator-view', GameSpectatorView);
